class OrderSampleError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'OrderSampleError';
    }
}

function isLocal(): boolean {
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

/**
 *
 *
 */
export function logAssetsError(message: string) {
    if (isLocal()) {
        /*                                  */
        console.warn(message);
    } else {
        window.setTimeout(() => {
            throw new OrderSampleError(message);
        }, 0);
    }
}
